import { Component, OnInit } from '@angular/core';
import { Service } from 'src/app/services';
import { LoadingScreenService } from 'src/app/services/loading-screen/loading-screen.service';
import { GlobalService } from '../../../global.service';
@Component({
  selector: 'app-iptv-support',
  templateUrl: './iptv-support.component.html',
  styleUrls: ['./iptv-support.component.sass']
})
export class IptvSupportComponent implements OnInit {
  public tabActive='Mis Equipos y Servicios';
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public selectBan;
  public token:string=sessionStorage.getItem("token");
  constructor(private services: Service,private loadingScreenService: LoadingScreenService,public global:GlobalService) { }

  ngOnInit() {
  }
  initializeData(){
    this.global.refreshDataTo(this.token);
  }
}
